import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
let svgSprite = '';

// 动态导入所有 SVG 文件并生成 sprite
const req = require.context('@/assets/svgs', true, /\.svg$/);
req.keys().forEach(req);

// 获取 sprite 内容
if (typeof window !== 'undefined' && document) {
  const sprites = document.querySelectorAll('svg defs symbol');
  if (sprites.length > 0) {
    let svgContent = '<svg xmlns="http://www.w3.org/2000/svg" style="display: none;">';
    sprites.forEach(sprite => {
      svgContent += sprite.outerHTML;
    });
    svgContent += '</svg>';
    svgSprite = svgContent;
  }
}
export default {
  name: 'SvgSprite',
  data() {
    return {
      svgSprite: svgSprite
    };
  }
};